( function( $ ) {
    // update training sidebar price when there is a discount code
    $( document ).on( 'iform-kortingscode-value-updated', function(e){
        
        if (!$('.trainingform-sidebar-price-container').length) {
            return false;
        }

        var discount = $('#kortingscode-value').val();
        var subtotal = $('.field__wrapper--subtotaalbedrag .field__wrapper__input--subtotaalbedrag span').html();
        var total = $('input[type="hidden"].field--totaalbedrag').val();

        if (discount > 0) {
            discount = discount / 100;
        }

        // add the subtotal price above the total price
        addPriceToSidebar('subtotal', subtotal, 'Subtotaal', false);

        // add the discount price above the total price
        addPriceToSidebar('discount', discount, 'Korting', true);

        // change the total value
        $('.trainingform-sidebar-price-current').html(total);
    } );



    function addPriceToSidebar(name, value, label, negative_value) {

        if (!value || value == 0) {
            $('.trainingform-sidebar-' + name + '-container').remove();
            return false;
        }

        // add the price above the total price
        if ($('.trainingform-sidebar-' + name + '-container').length) {
            if ( $.isNumeric(value) && value > 0) {
                $('.trainingform-sidebar-' + name + '-container .trainingform-sidebar-' + name + '-price').html((negative_value ? '- ' : '') + '€ ' + value.toFixed( 2 ).toString().replace(".", ","));
            } else {
                $('.trainingform-sidebar-' + name + '-container .trainingform-sidebar-' + name + '-price').html(value);
            }
        } else {
            $('.trainingform-sidebar-price-container').before(
                '<div class="trainingform-sidebar-' + name + '-container">' +
                    '<div class="trainingform-sidebar-' + name + '-header">' + label + '</div>' +
                    '<div class="trainingform-sidebar-' + name + '-price">' +
                        (negative_value ? '- ' : '') + ( $.isNumeric(value) ? '€ ' + value.toFixed( 2 ).toString().replace(".", ",") : value) + 
                    '</div>' +
                '</div>'
            );
        }
    }


    if ( $( ".iform-detail .iform_holder" ).length ) {
        //hide adresgegevens if no address is needed
        if ( !$( ".iform_holder .nawbetaler_adres_postcode" ).length ) {
            $( ".field__wrapper--section_title_1" ).hide();
        }

        // copy the first edition text to the sidebar
        if( $( '.order-content-item.ingangseditie' ).length ) {
            var sidebar_value = "";

            // hidden field
            if( $( "input.field--ingangsedities" ).length ) {
                sidebar_value = $( "input.field--ingangsedities" ).val();
            }

            // displayed as text
            if( $( ".field__wrapper__input--ingangsedities" ).length ) {
                sidebar_value = $( ".field__wrapper__input--ingangsedities label span" ).html();
            }

            // displayed as select field
            if( $( 'select.ingangsedities' ).length ) {
                sidebar_value = $( 'select.ingangsedities option:selected' ).text();

                $( 'select.ingangsedities' ).on( 'change', function() {
                    $( '.order-content-item.ingangseditie .value' ).html( $( this ).find( 'option:selected' ).text() );
                } );
            }

            if( sidebar_value ) {
                $( '.order-content-item.ingangseditie .value' ).html( sidebar_value );
            } else {
                if( !$( '.order-content-item.ingangseditie .value' ).text().trim().length ) {
                    $( ".order-content-item.ingangseditie .label" ).html( "Ingangsdatum" );
                    $( '.order-content-item.ingangseditie .value' ).html( "per direct" );
                }
            }
        }
    }


    if( $( '.trainingform' ).length || $( '.page-iform .iform_holder' ).length ) {
        if( $( '.confirm.field__wrapper--nawbetaler_emailadres' ).length && $( '.proefles-form' ).length ) {
            //$( '.steps-container .step1' ).removeClass( 'active' );
            //$( '.steps-container .step1' ).addClass( 'done' );
            //$( '.steps-container .step2' ).addClass( 'active' );
            $( '.col2' ).css( 'display', 'none' );
        } else if( $( '.wpm-iforms-submit-confirm' ).length || $( '.iforms_result_page' ).length ) {
            //$( '.steps-container .step1' ).removeClass( 'active' );
            //$( '.steps-container .step1' ).addClass( 'done' );
            //$( '.steps-container .step2' ).addClass( 'active' );
        }
        if( $( '.iforms_result_page' ).length ) {
            $( '.col2' ).css( 'display', 'none' );
        }
        if( $( '#prijsartikel' ).length ) {
            $( '.order-content-title' ).html( $( '.field__wrapper__input--artikelkeuzes label span' ).html() );
            $( '.order-content-price .value' ).html( $( '#prijsartikel' ).val() );
        } else if ( $( '#totaalbedrag' ).length ) {
            $( '.order-content-title' ).html( $( '.field__wrapper__input--artikelkeuzes label span' ).html() );
            $( '.order-content-price .value' ).html( $( '#totaalbedrag' ).val() );
        }
    }
} )( jQuery );
